import { render, staticRenderFns } from "./PatientReviewPage.vue?vue&type=template&id=7026495a&scoped=true"
import script from "./PatientReviewPage.vue?vue&type=script&lang=js"
export * from "./PatientReviewPage.vue?vue&type=script&lang=js"
import style0 from "./PatientReviewPage.vue?vue&type=style&index=0&id=7026495a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7026495a",
  null
  
)

export default component.exports